import axios from 'axios';
import { ROUTE_API } from 'configs';
import auth_service from './authService';

const AxiosInstance = axios.create({
    baseURL: ROUTE_API.index,
    timeout: 5000
});
AxiosInstance.interceptors.request.use(
    (config: any) => {
        const accessToken: string = auth_service.getAccessToken();
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        if (config.headers.isShowLoading) {
            // requestCount++;
            // dispatch(showLoading());
        }
        return config;
    },
    (err: any) => {
        if (err.config.headers.isShowLoading) {
            // decreaseRequestCount();
        }
        return Promise.reject(err.response);
    }
);
AxiosInstance.interceptors.response.use(
    (res: any) => {
        if (res.config.headers.isShowLoading) {
            // decreaseRequestCount();
        }
        return res;
    },
    (err: any) => {
        if (err.config.headers.isShowLoading) {
            // decreaseRequestCount();
        }
        if (err.response?.status === 401) {
            window.localStorage.removeItem('accessToken');
        }
        return Promise.reject(err.response);
    }
);

export default AxiosInstance;